// Studio OS — Maintenance data
// Tickets tie inventory items (by id) to maintenance contacts (MT-xxx by id).

// Today's date in local time as "YYYY-MM-DD" — the format tickets store.
// (toISOString would give the UTC date, which is wrong late in the evening.)
function maintToday() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

// ─── Tickets — open issues, repairs, preventive jobs ─────────────────
const MAINT_TICKETS = [
  {
    id: "TK-1042",
    title: "Intermittent crackle on output",
    itemId: "MIC-006",            // Neumann KM 84 #2
    type: "repair",
    status: "out",                // open | in-progress | out (at tech) | scheduled | done
    priority: "high",
    assignedTo: "MT-001",         // Eli Mercenary
    opened: "2026-04-22",
    due: "2026-06-12",            // ETA back
    estCost: 280,
    room: "—",
    log: [
      { date: "2026-04-22", who: "Rae Okafor", text: "Crackle on KM84 #2 during Marlowe overheads. Pulled from rotation." },
      { date: "2026-04-23", who: "Jonah C.", text: "Shipped to Mercenary Audio for capsule + connector check." },
      { date: "2026-05-30", who: "Eli Mercenary", text: "Cold solder joint at XLR. Re-flowed, cleaned capsule. Bench-testing 48h." },
    ],
    notes: "Pair-matched with MIC-005 — keep them together when it's back.",
  },
  {
    id: "TK-1048",
    title: "Console recap — channels 16–32",
    itemId: null,
    itemLabel: "Neve 8068 MkII · Studio B",
    type: "preventive",
    status: "scheduled",
    priority: "med",
    assignedTo: "MT-003",         // Tomás Reyes
    opened: "2026-05-18",
    due: "2026-06-10",
    estCost: 2800,
    room: "Studio B",
    log: [
      { date: "2026-05-18", who: "Jonah C.", text: "Channels 24–28 getting noisy. Tomás quoted full recap of upper half." },
      { date: "2026-06-01", who: "Tomás Reyes", text: "Caps ordered. Booked 4-hour block 6/10 morning before Sable Mountain." },
    ],
    notes: "Must finish before noon — Sable Mountain drum tracking starts 1pm in B.",
  },
  {
    id: "TK-1051",
    title: "Quarterly tuning + voicing",
    itemId: null,                 // Steinway B — not an inventory item
    itemLabel: "Steinway B (7')",
    type: "calibration",
    status: "scheduled",
    priority: "med",
    assignedTo: "MT-002",         // Esperanza Vega
    opened: "2026-05-25",
    due: "2026-06-09",
    estCost: 450,
    room: "Studio A",
    log: [
      { date: "2026-05-25", who: "Jonah C.", text: "Standing quarterly. Esperanza confirmed Monday 6/9 AM before 11." },
    ],
    notes: "She comes before 11am. Cash or check on the day.",
  },
  {
    id: "TK-1053",
    title: "VF-14 tube hours — log + inspect",
    itemId: "MIC-001",           // U 47
    type: "preventive",
    status: "open",
    priority: "low",
    assignedTo: "MT-001",         // Eli Mercenary
    opened: "2026-06-02",
    due: "2026-07-15",
    estCost: 0,
    room: "Studio A",
    meter: { label: "Tube hours since retube", value: 1840, max: 2500, unit: "hrs" },
    log: [
      { date: "2026-06-02", who: "Jonah C.", text: "Approaching 2000h on the VF-14. Schedule a check w/ Eli before the next album cycle." },
    ],
    notes: "Original VF-14 — irreplaceable. Don't run it to failure.",
  },
  {
    id: "TK-1055",
    title: "Distressor — intermittent power",
    itemId: "OUT-005",           // Distressor EL8X
    type: "repair",
    status: "in-progress",
    priority: "high",
    assignedTo: "MT-006",         // Lila Friedman
    opened: "2026-06-05",
    due: "2026-06-15",
    estCost: 180,
    room: "Studio B",
    log: [
      { date: "2026-06-05", who: "Diane Park", text: "Unit drops out when rack warms up. Suspect PSU." },
      { date: "2026-06-06", who: "Lila Friedman", text: "On the bench. Reflow + cap check on the supply rail." },
    ],
    notes: "",
  },
  {
    id: "TK-1057",
    title: "Annual head alignment",
    itemId: null,
    itemLabel: "Studer A800 · Machine Room",
    type: "calibration",
    status: "open",
    priority: "low",
    assignedTo: "MT-004",         // Doug Hartley
    opened: "2026-06-04",
    due: "2026-09-30",
    estCost: 1800,
    room: "—",
    log: [
      { date: "2026-06-04", who: "Jonah C.", text: "Annual maintenance due Q4. Reach out to Doug to book." },
    ],
    notes: "Slow to email — call him.",
  },
  {
    id: "TK-1039",
    title: "Isolation transformer service",
    itemId: null,
    itemLabel: "Balanced power · all rooms",
    type: "preventive",
    status: "done",
    priority: "med",
    assignedTo: "MT-005",         // Studio Power Solutions
    opened: "2026-05-02",
    due: "2026-05-14",
    closed: "2026-05-14",
    estCost: 600,
    actualCost: 575,
    room: "—",
    log: [
      { date: "2026-05-02", who: "Jonah C.", text: "Annual service on the iso transformer." },
      { date: "2026-05-14", who: "Studio Power", text: "Serviced, torqued lugs, logged ground readings. All nominal." },
    ],
    notes: "Service contract renews 9/26.",
  },
  {
    id: "TK-1031",
    title: "LA-2A retube",
    itemId: "OUT-003",           // LA-2A
    type: "repair",
    status: "done",
    priority: "med",
    assignedTo: "MT-006",         // Lila Friedman
    opened: "2026-03-20",
    due: "2026-03-30",
    closed: "2026-03-30",
    estCost: 240,
    actualCost: 240,
    room: "—",
    log: [
      { date: "2026-03-20", who: "Cole Imani", text: "Getting microphonic. Time for fresh tubes." },
      { date: "2026-03-30", who: "Lila Friedman", text: "Retubed, re-biased, gain staged. Sounds new." },
    ],
    notes: "Silver-face — keep using NOS tubes only.",
  },
];

// ─── Preventive schedule — recurring upkeep (calendar of upkeep) ─────
const MAINT_SCHEDULE = [
  { id: "SCH-1", label: "Steinway B tuning",        itemId: null, itemLabel: "Steinway B (7')", cadence: "Quarterly",  next: "2026-06-09", contact: "MT-002" },
  { id: "SCH-2", label: "HVAC filter + service",     itemId: null, itemLabel: "All rooms", cadence: "Quarterly", next: "2026-07-01", contact: "MT-008" },
  { id: "SCH-3", label: "Console recap (B, lower)",  itemId: null, itemLabel: "Neve 8068 · B", cadence: "As needed", next: "2026-06-10", contact: "MT-003" },
  { id: "SCH-4", label: "Studer A800 alignment",     itemId: null, itemLabel: "Studer A800", cadence: "Annual",    next: "2026-09-30", contact: "MT-004" },
  { id: "SCH-5", label: "Tube mic inspection",       itemId: "MIC-001", cadence: "Annual",    next: "2026-07-15", contact: "MT-001" },
  { id: "SCH-6", label: "Iso transformer service",   itemId: null, itemLabel: "Balanced power", cadence: "Annual", next: "2026-09-26", contact: "MT-005" },
];

const MAINT_TYPE_META = {
  repair:      { label: "Repair",      glyph: "⚙", color: "oklch(0.70 0.18 25)" },
  preventive:  { label: "Preventive",  glyph: "◷", color: "oklch(0.74 0.12 240)" },
  calibration: { label: "Calibration", glyph: "⌖", color: "oklch(0.74 0.14 300)" },
  inspection:  { label: "Inspection",  glyph: "◎", color: "oklch(0.74 0.14 200)" },
};

const MAINT_STATUS_META = {
  open:          { label: "Open",        color: "oklch(0.80 0.14 60)"  },
  "in-progress": { label: "In progress", color: "oklch(0.74 0.14 200)" },
  out:           { label: "At tech",     color: "oklch(0.74 0.14 300)" },
  scheduled:     { label: "Scheduled",   color: "oklch(0.72 0.12 240)" },
  done:          { label: "Closed",      color: "oklch(0.72 0.14 145)" },
};

const MAINT_PRIORITY_META = {
  high: { label: "High", color: "oklch(0.70 0.18 25)" },
  med:  { label: "Med",  color: "oklch(0.78 0.14 60)" },
  low:  { label: "Low",  color: "oklch(0.55 0.010 80)" },
};

// Next ticket id. Numbers start after 1000 and are never reused (see nextTag).
function maintNextTicketId() {
  return nextTag("maintenance_tickets", /^TK-(\d+)$/, n => "TK-" + n, 1000);
}

// Opens a ticket against a gear item and flags the item so it surfaces in
// "needs attention" filters. Used by the gear drawer and the scanner.
function maintLogFault(item, { title, type = "repair", priority = "med", notes = "" }) {
  const ticket = {
    id: maintNextTicketId(),
    title,
    itemId: item.id,
    type,
    status: "open",
    priority,
    assignedTo: null,
    opened: maintToday(),
    due: null,
    estCost: 0,
    room: (item.room && item.room !== "—") ? item.room : (item.location || "—"),
    log: [{ date: maintToday(), who: "JC", text: notes.trim() || title }],
    notes: notes.trim(),
  };
  MAINT_TICKETS.push(ticket);
  item.condition = "attention";
  // Saved directly rather than left to the app-level debounced autosave —
  // that effect only re-runs when App itself re-renders.
  save(STORE_ORG, "maintenance_tickets", MAINT_TICKETS);
  save(STORE_ORG, "inventory", INVENTORY);
  return ticket;
}

Object.assign(window, {
  maintToday, maintLogFault, maintNextTicketId, MAINT_TICKETS, MAINT_SCHEDULE,
  MAINT_TYPE_META, MAINT_STATUS_META, MAINT_PRIORITY_META,
});
